/**
 * @format
 * @flow strict-local
 */
/*
	NOTE
	- 

	TODO
	-

	NICE TO HAVE/NEXT
	- 
*/
// DEPENDENCIES

import AppView from "./components/views/AppView";
import AuthView from "./components/views/AuthView";

import routes from "./configs/routes";

import Account from "./screens/Account";
import Cops from "./screens/Cops";
import Dashboard from "./screens/Dashboard";
import ForgotPassword from "./screens/ForgotPassword";
import Lists from "./screens/Lists";
import Messages from "./screens/Messages";
import NotFound from "./screens/NotFound";
import ResendActivationCode from "./screens/ResendActivationCode";
import Reservation from "./screens/Reservation";
import SignIn from "./screens/SignIn";
import SignUp from "./screens/SignUp";
import StoreRules from "./screens/StoreRules";

// INIT

const router = [];
const screenComponents = {
	Account,
	Cops,
	Dashboard,
	ForgotPassword,
	Lists,
	Messages,
	NotFound,
	ResendActivationCode,
	Reservation,
	SignIn,
	SignUp,
	StoreRules
};
const viewComponents = {
	AppView,
	AuthView
};

// ROUTER

Object.keys(routes).map((routeKey) => {
	const routeItem = routes[routeKey];

	router.push({
		path: routeItem.url,
		screenComponent: screenComponents[routeItem.screenComponent],
		viewComponent: viewComponents[routeItem.viewComponent]
	});
});

// EXPORT

export default router;
